var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TopNav'),_c('SideNav'),_c('router-view',{staticClass:"page-view"}),_c('LoadingProgress'),_c('NotificationAlert'),_c('LogoutDialog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }